export default {"src":"/_next/static/media/xuc.960ebcbb.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};